/* Extra Elettronica · movimento del tema "Nero e Rosso" (copia non pubblicata).
   - barra rossa di avanzamento in cima alla pagina
   - bagliore rosso dell'apertura che segue il puntatore (solo con mouse)
   - comparsa a cascata di titoli, schede prodotto e passaggi
   Con "riduci movimento" attivo: niente bagliore che segue il puntatore, e le comparse restano solo dissolvenze (lo decide il CSS). */
(function () {
  'use strict';
  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    var bar = document.createElement('div');
    bar.className = 'xm-progress'; bar.setAttribute('aria-hidden', 'true');
    document.body.appendChild(bar);
    var pending = false;
    function paint() {
      pending = false;
      var max = root.scrollHeight - window.innerHeight;
      bar.style.transform = 'scaleX(' + (max > 0 ? Math.min(1, window.scrollY / max) : 0).toFixed(4) + ')';
    }
    window.addEventListener('scroll', function () { if (!pending) { pending = true; requestAnimationFrame(paint); } }, { passive: true });
    window.addEventListener('resize', paint);
    paint();

    var hero = document.querySelector('.xb-hero');
    if (!reduce && hero && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      var raf = 0;
      hero.addEventListener('pointermove', function (e) {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = 0;
          var r = hero.getBoundingClientRect();
          hero.style.setProperty('--mx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
          hero.style.setProperty('--my', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
        });
      });
    }

    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        /* anche cio' che sta sopra lo schermo (pagina riaperta a meta') va mostrato */
        if (en.isIntersecting || en.boundingClientRect.top < 0) { en.target.classList.add('xm-in'); io.unobserve(en.target); }
      });
    }, { threshold: .12, rootMargin: '0px 0px -30px 0px' });
    function tag(list, step, cols) {
      Array.prototype.forEach.call(list, function (el, i) {
        if (el.classList.contains('xm-r') || el.hasAttribute('data-xb-reveal') || el.hidden) return;
        el.classList.add('xm-r');
        el.style.setProperty('--xm-d', ((cols ? i % cols : i) * step).toFixed(2) + 's');
        io.observe(el);
      });
    }
    var main = document.getElementById('MainContent') || document;
    tag(main.querySelectorAll('.xb-sec__head, .title-wrapper-with-link'), 0);
    tag(main.querySelectorAll('.product-grid:not([data-xb-phone-grid]) > .grid__item'), .07, 4);
    tag(main.querySelectorAll('.xb-val__steps li'), .1);
    tag(main.querySelectorAll('.xb-store__list li'), .1);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();